import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { ArrowBack, BookmarkAddOutlined } from "@mui/icons-material";
  
const InviteManagementTableTopToolbar = ({ table,setOpenSessionModal}) => {
  return (
    <Box
      sx={{
        display: "flex",
        gap: "16px",
        padding: "8px",
        alignItems: "center",
      }}
    >
      <Typography sx={{ fontSize: "16px", color: "#626262" }}>
        Invite History
      </Typography>
      <Button startIcon={<BookmarkAddOutlined />} variant="outlined"
       onClick={()=>setOpenSessionModal(true)}
      >
        Create session
      </Button>
    </Box>
  );
};

export default InviteManagementTableTopToolbar;